import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import { Set_WmsInnModelCheckbox } from "../SliceGRV";
import MoreHorizOutlinedIcon from "@mui/icons-material/MoreHorizOutlined";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {
  CmpTypographyField,
  CmpInputField,
  CmpCheckboxField,
  CmpButtonKWithIcon,
} from "../../../Component/Common/ToolBox/ToolBox";
import Grid from "@mui/material/Grid";
import GCTitleSticky from "../../../Component/Common/ReuseableComponent/GCTitleSticky";
import { CmpSelectArrFieldV1, CmpSelectFieldV1, CmpTextFieldV1 } from "../../../Component/Common/ToolBox/ToolBoxV1";
import GCToggleSearchV1 from "../../../Component/Common/ReuseableComponent/GCToggleSearchV1";

export default function GCContent({
  sTransItemStockObj,
  xTransItemStockShow,
  fonChangeInputLDiscAmt,
  fGrossAmt,
  fFocusShowSalesHistoryGrid,
  xItemStock,
  vRdxWmsHead,
  xKey,
  xFocusInput,
  xBufferObj,
  sUnit,
  sFocFlagArr,
  fFocFlag,
  fFoc,
  sTypeArr,
  vRdxGRNtax1,
  vRdxGRNtax2,
  fUnit,
  fUnitRate,
  fUnitRateSave_onKeyUp,
  fLDiscPer,

  fExcise,
  fNetExcise,
  fTaxGroup,
  fCessGroup,
  fNetAmt,
  fItemName,
  fOpenContentItemSearchModalKey,
  fQty,
  fQtyEnter,
  fBaseRate,
  //toggle
  xMediaQuery,
  xonClickbtn,
  xrows,
  xcolumns,
  xRowCellClick,
  xRowClick,
  xToggle,
  xData,
  xOnChangeDropdownInput,
  xDropdownObj,
  xOnKeyUpDropdownInput,
  xErrorMsgDetail,
  xContent_Focus,
  xContent_Blur,

  //narration
  fNarration,
  fNarrationKeyEnter,
  xNarrationToggleDropdown,
  xrowDropdownNarrationSearch,
  xOnCellKeyNarrationDown,
  xOnRowNarrationClick,

  setBufferObj,
  fModalPoType,
  fModalPoNo,
  fReason=()=>{},
  sReason=[]
}) {
  const dispatch = useDispatch();
  const vRdxCheckbox = useSelector(
    (state) => state.SliceGRV.value.GRVCheckbox
  );
  const vModelCheckboxArr = [
    { name: "SplDisc", rdxName: vRdxCheckbox.SplDisc },
    { name: "TDiscPercent", rdxName: vRdxCheckbox.TDiscPercent },
    { name: "TDiscAmt", rdxName: vRdxCheckbox.TDiscAmt },
    { name: "LDiscPercent", rdxName: vRdxCheckbox.LDiscPercent },
    { name: "LDiscAmt", rdxName: vRdxCheckbox.LDiscAmt },
    { name: "Excise", rdxName: vRdxCheckbox.Excise },
    { name: "Tax", rdxName: vRdxCheckbox.Tax },
    { name: "Cess", rdxName: vRdxCheckbox.Cess },
    { name: "AddCess", rdxName: vRdxCheckbox.AddCess },
    { name: "FOC", rdxName: vRdxCheckbox.FOC },
    { name: "GRN", rdxName: vRdxCheckbox.GRN },
    { name: "ItmCd", rdxName: vRdxCheckbox.ItmCd },
    // { name: "Srno", rdxName: vRdxCheckbox.Srno },
    // { name: "Total", rdxName: vRdxCheckbox.Total },
    { name: "BaseQty", rdxName: vRdxCheckbox.BaseQty },
    { name: "BaseRate", rdxName: vRdxCheckbox.BaseRate },
    { name: "PackQty", rdxName: vRdxCheckbox.PackQty },
  ];
  const [sIsChecked, setIsChecked] = useState(false);
  const [sGrnCheckBox, setGrnCheckbox] = useState(vRdxCheckbox);
  const [sOpenContentModal, setOpenContentModal] = useState(false);
  const fModalContentOpen = () => {
    setOpenContentModal(true);
  };

  const fModalContentClose = () => {
    setOpenContentModal(false);
  };
  const fSetCheckBox = (e) => {
    const nameValue = e.target.name;
    const iSCheck = e.target.checked;
    setGrnCheckbox((values) => ({ ...values, [nameValue]: iSCheck }));
  };
  const fIsAllChecked = (e) => {
    const iSCheck = e.target.checked;
    setIsChecked(iSCheck);
    const updatedObj = Object.keys(vRdxCheckbox).reduce((acc, key) => {
      acc[key] = iSCheck;
      return acc;
    }, {});

    // Update the state with the new object
    setGrnCheckbox(updatedObj);
  };
  useEffect(() => {
    dispatch(Set_WmsInnModelCheckbox(sGrnCheckBox));
    const vIsAllTrue = Object.values(sGrnCheckBox).every(
      (value) => value === true
    );
    setIsChecked(vIsAllTrue);
  }, [sGrnCheckBox]);
  return (
    <form className="Wms-inbound-grn-content" id="GRVContent">
      <Grid container spacing={0.9} columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
      <Grid
          item
          xs={12}
          sm={12}
          md={12}
          container
          textAlign={"end"}
          justifyContent={"end"}
        >
          <Grid
            item
            xs={12}
            sm={12}
            md={3}
            
          >
             
          </Grid>
          <Grid item xs={9} sm={9} md={3}>
          <div className="d-flex justify-content-between">
            
            <span
              className={
                vRdxWmsHead.A_DocStat == "POST"
                  ? "hide-all-time"
                  : "d-flex justify-content-between align-items-center"
              }
            >
              <CmpTypographyField
                xcomponent={"span"}
                xText={"Stock=" + sTransItemStockObj.RPStock}
              />{" "}
              &nbsp; &nbsp;
              {xTransItemStockShow >= 0 ? (
                <>
                  <CmpTypographyField
                    xcomponent={"span"}
                    xText={" CostPr=" + sTransItemStockObj.CostPr}
                  />
                  &nbsp;&nbsp;
                  <CmpTypographyField
                    xcomponent={"span"}
                    xText={"LPRate=" + sTransItemStockObj.LPRate}
                  />{" "}
                </>
              ) : (
                <></>
              )}
              &nbsp; &nbsp;
              
            </span>
          </div>
            
          </Grid>
          {!xMediaQuery && (
          <Grid item xs={3} sm={3} md={3}>
            <MoreHorizOutlinedIcon
              onClick={fModalContentOpen}
              className="form-label gnr-title-txt"
            />
          </Grid>)}
        </Grid>
        {/* <Grid item xs={12} sm={1} md={1}   className={vRdxCheckbox.Srno ? "lastkeyDetect" : "hide-content"}>
          
         <CmpTextFieldV1
            xLabelText="S.No"
            xSize="small"
            xValue={xBufferObj.B_Srno}
            xType={"text"} // text/number/password
            xName={"B_Srno"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsgDetail.B_Srno === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_Srno}
          // xOnKeyUp={xKey}
          />
        </Grid> */}
        <Grid item xs={4.5} sm={3} md={2}      className={vRdxCheckbox.GRN ? "lastkeyDetect" : "hide-content"}
       >
          {/* <CmpTypographyField xcomponent={"div"} xText={"GRN Type"} /> */}
          {/* <CmpInputField
            xValue={xBufferObj.B_RefDocTyp}
            xType={"text"} // text/number/password
            xName={"B_RefDocTyp"}
            xReadOnly={true}
            xOnChange={""}
            xError={false}
            xErrorMessage={""}
            // xOnKeyUp={xKey}
          /> */}
          <GCToggleSearchV1
            xtabIndex={"101"}
            xLabelText={"GRN Type"}
            xName={"B_RefDocTypName"}
            xType={"text"}
            xValue={xBufferObj?.B_RefDocTypName}
            xReadOnly={false}
            xOnChange={(e) => {
              setBufferObj((obj) => ({
                ...obj,
                B_RefDocTyp: "",
                B_RefDocTypName: e.target.value,
              }))
            }}
            xOnKeyUp={fModalPoType}
            xonClickbtn={fModalPoType}
            xError={false}
            xErrorMessage={""}
          />
        </Grid>
        <Grid item xs={5.5} sm={4} md={2}   className={vRdxCheckbox.GRN ? "lastkeyDetect" : "hide-content"}
       >
          {/* <CmpTypographyField xcomponent={"div"} xText={"GRN No"} /> */}
          {/* <CmpInputField
            xValue={xBufferObj.B_RefDocNo}
            xType={"text"} // text/number/password
            xName={"B_RefDocNo"}
            xReadOnly={true}
            xOnChange={""}
            xError={true}
            xErrorMessage={""}
            // xOnKeyUp={xKey}
          /> */}
          <GCToggleSearchV1
            xLabelText="GRN No"
            xtabIndex={"101"}
            xName={"B_RefDocNo"}
            xType={"text"}
            xValue={xBufferObj?.B_RefDocNo}
            xReadOnly={false}
            xOnChange={(e) => {
              setBufferObj((obj) => ({
                ...obj,
                B_RefDocNo: e.target.value,
              }))
            }}
            xOnKeyUp={fModalPoNo}
            xonClickbtn={fModalPoNo}
            xError={false}
            xErrorMessage={""}
          />
        </Grid>
        <Grid item xs={12} sm={4} md={2} lg={1}  className={vRdxCheckbox.ItmCd ? "lastkeyDetect" : "hide-content"  }>
          {/* <CmpTypographyField xcomponent={"div"} xText={"Item Code"} /> */}
          <CmpTextFieldV1
            xLabelText="Item Code"
              xSize="small"
            xValue={xBufferObj.B_Itmcd}
            xType={"text"} // text/number/password
            xName={"B_Itmcd"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsgDetail.B_Itmcd === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_Itmcd}
          // xOnKeyUp={xKey}
          />
        </Grid>
        {/* <Grid item xs={3} sm={2} md={2} lg={1.5}>
          <CmpTypographyField xcomponent={"div"} xText={"Bar Code"} />
          <CmpInputField
            xValue={xBufferObj.B_Barcode}
            xType={"text"} // text/number/password
            xName={"B_Barcode"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsgDetail.B_Barcode === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_Barcode}
            // xOnKeyUp={xKey}
          />
        </Grid> */}
        <Grid
          item
          xs={12}
          sm={10}
          // sm={"auto"}
          // md={"auto"}
          // lg={"auto"}
          md={xToggle ? 5 : 4}
          // lg={5}
          className="lastkeyDetect"
        >
          {/* {xMediaQuery ? (
            <Grid
              container
              spacing={0}
              columns={{ xs: 12, sm: 12, md: 12, }}
              className={
                vRdxWmsHead.A_DocStat == "POST"
                  ? "hide-all-time"
                  : "d-flex justify-content-between align-items-center"
              }
            >
              <Grid item xs={4}>
                <CmpTypographyField
                  xcomponent={"span"}
                  xText={"Stock=" + sTransItemStockObj.RPStock}
                />
              </Grid>
              <Grid item xs={4} className={
                xTransItemStockShow >= 0
                  ? ""
                  : "hide-all-time"
              }>
                <CmpTypographyField
                  xcomponent={"span"}
                  xText={" CostPr=" + sTransItemStockObj.CostPr}
                />
              </Grid>
              <Grid item xs={4}
                className={
                  xTransItemStockShow >= 0
                    ? ""
                    : "hide-all-time"
                }
              >
                <CmpTypographyField
                  xcomponent={"span"}
                  xText={"LPRate=" + sTransItemStockObj.LPRate}
                />
              </Grid>
              <Grid item xs={12}>
                <CmpTypographyField xcomponent={"span"} xText={"Item Name"} />
              </Grid>
            </Grid>
          ) : (
          <div className="d-flex justify-content-between">
            <span className="itemName-field">
              <CmpTypographyField xcomponent={"span"} xText={"Item Name"} />
            </span>
            <span
              className={
                vRdxWmsHead.A_DocStat == "POST"
                  ? "hide-all-time"
                  : "d-flex justify-content-between align-items-center"
              }
            >
              <CmpTypographyField
                xcomponent={"span"}
                xText={"Stock=" + sTransItemStockObj.RPStock}
              />{" "}
              &nbsp; &nbsp;
              {xTransItemStockShow >= 0 ? (
                <>
                  <CmpTypographyField
                    xcomponent={"span"}
                    xText={" CostPr=" + sTransItemStockObj.CostPr}
                  />
                  &nbsp;&nbsp;
                  <CmpTypographyField
                    xcomponent={"span"}
                    xText={"LPRate=" + sTransItemStockObj.LPRate}
                  />{" "}
                </>
              ) : (
                <></>
              )}
              &nbsp; &nbsp;
            
            </span>
          </div>)} */}


          <GCToggleSearchV1
          xName={"B_ItmName"}
             xLabelText="Item Name"
            xtabIndex={"101"}
            xType={"text"}
            xValue={xBufferObj?.B_ItmName}
            xReadOnly={false}
            xOnChange={fItemName}
            xOnKeyUp={fOpenContentItemSearchModalKey}
            xError={xErrorMsgDetail.B_ItmName === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_ItmName}
            xMediaQuery={xMediaQuery}
            xonClickbtn={xonClickbtn}
            xrows={xrows}
            xcolumns={xcolumns} //head
            xRowCellClick={xRowCellClick}
            xRowClick={xRowClick}
            xToggle={xToggle}
            xData={xData}
            xOnChangeDropdownInput={xOnChangeDropdownInput}
            xDropdownObj={xDropdownObj}
            xOnKeyUpDropdownInput={xOnKeyUpDropdownInput}
          />
        </Grid>
        <Grid item xs={4} sm={2} md={1}   className="lastkeyDetect">
          {/* <CmpTypographyField xcomponent={"div"} xText={"Qty"} /> */}
          <CmpTextFieldV1
            xLabelText="Qty"
            xSize="small"
            xtabIndex={"102"}
            xValue={xBufferObj.B_Qty}
            xType={"number"} // text/number/password
            xName={"B_Qty"}
            xReadOnly={false}
            xOnChange={fQty}
            xError={xErrorMsgDetail.B_Qty === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_Qty}
            xOnKeyUp={(e) => {
              // fKeyTabInput(e, "B_Unit");
              fQtyEnter(e)
            }}
            xonFocus={(e) => {
              xContent_Focus(e);
              fFocusShowSalesHistoryGrid(e);
            }}
            xonBlur={xContent_Blur}
          />
        </Grid>
        <Grid item xs={4} sm={2} md={1} lg={1.5} className="lastkeyDetect">
          {/* <CmpTypographyField xcomponent={"div"} xText={"Unit"} /> */}
          <CmpSelectFieldV1
            xSize="small"
            xtabIndex={"103"}
            xLabelText="Unit1"
            xValue={xBufferObj.B_Unit}
            xOnChange={fUnit}
            xName={"B_Unit"}
            xData={sUnit}
            xValueMember={""}
            xDispalyMember={""}
            xError={xErrorMsgDetail.B_Unit === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_Unit}
            xDisable={false}
            xonFocus={(e) => {
              fFocusShowSalesHistoryGrid(e);
            }}
            xonBlur={xContent_Blur}
          />
        </Grid>
         <Grid item xs={4} sm={2} md={1} lg={1.5} className="lastkeyDetect">
              <CmpSelectFieldV1
                xLabelText="Reason"
                xSize="small"
                xValue={xBufferObj?.B_Reason}
                xOnChange={fReason}
                xName={"B_Reason"}
                xData={sReason}
                xValueMember={""}
                xDispalyMember={""}
                xError={xErrorMsgDetail.B_Reason === "" ? false : true}
                xErrorMessage={xErrorMsgDetail.B_Reason}
                xDisable={false}
                xtabIndex={"8"}
              />
            </Grid>

        {vRdxCheckbox.PackQty && <Grid item xs={4} sm={1} md={1}  className="lastkeyDetect">
          {/* <CmpTypographyField xcomponent={"div"} xText={" Unit Rate"} /> */}
          <CmpTextFieldV1
            xLabelText="PackQty"
            xSize="small"
            xtabIndex={"104"}
            xValue={xBufferObj.B_PackQty}
            xType={"number"} // text/number/password
            xName={"B_URateFc"}
            xReadOnly={true}
            xOnChange={()=>{}}
            xError={false}
            xErrorMessage={""}
          />
        </Grid>}
        <Grid item xs={4} sm={2} md={1} lg={1} className="lastkeyDetect">
          {/* <CmpTypographyField xcomponent={"div"} xText={" Unit Rate"} /> */}
          <CmpTextFieldV1
            xLabelText="Unit Rate"
            xSize="small"
            xtabIndex={"104"}
            xValue={xBufferObj.B_URateFc}
            xType={"number"} // text/number/password
            xName={"B_URateFc"}
            xReadOnly={false}
            xOnChange={fUnitRate}
            xError={xErrorMsgDetail.B_URateFc === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_URateFc}
            xonFocus={(e) => {
              xContent_Focus(e);
              fFocusShowSalesHistoryGrid(e);
            }}
            xonBlur={xContent_Blur}
            xOnKeyUp={(e) => fUnitRateSave_onKeyUp(e)}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={1}
          md={1}
          lg={1}
          className={vRdxCheckbox.SplDisc ? "lastkeyDetect" : "hide-content"}
        >
          {/* <CmpTypographyField xcomponent={"div"} xText={"Spl.Disc"} /> */}
          <CmpTextFieldV1
            xLabelText="Spl.Disc"
            xSize="small"
            xValue={xBufferObj.SplDisc}
            xType={"text"} // text/number/password
            xName={"SplDisc"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsgDetail.SplDisc === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.SplDisc}
            xonFocus={(e) => {
              fFocusShowSalesHistoryGrid(e);
            }}
            xonBlur={xContent_Blur}
          // xOnKeyUp={xKey}
          />
        </Grid>

        <Grid item xs={4} sm={1} md={1} lg={1} className={vRdxCheckbox.BaseQty ? "lastkeyDetect" : "hide-content"}  >
          {/* <CmpTypographyField xcomponent={"div"} xText={"BaseQty"} /> */}
          <CmpTextFieldV1
            xLabelText="BaseQty"
            xSize="small"
            xValue={xBufferObj.B_BaseQty}
            xType={"text"} // text/number/password
            xName={"B_BaseQty"}
            xReadOnly={true}
            xOnChange={""}
            xError={false}
            xErrorMessage={""}
            xonFocus={(e) => {
              fFocusShowSalesHistoryGrid(e);
            }}
            xonBlur={xContent_Blur}
          // xOnKeyUp={xKey}
          />
        </Grid>
       
        <Grid item xs={4} sm={2} md={1} lg={1} className="lastkeyDetect">
          {/* <CmpTypographyField xcomponent={"div"} xText={"Gross Amt"} /> */}
          <CmpTextFieldV1
            xLabelText="Gross Amt"
            xSize="small"
            xtabIndex={"105"}
            xValue={xBufferObj.B_GrossAmt}
            xType={"text"} // text/number/password
            xName={"B_GrossAmt"}
            xReadOnly={false}
            xOnChange={fGrossAmt}
            xError={xErrorMsgDetail.B_GrossAmt === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_GrossAmt}
            xonFocus={(e) => {
              xContent_Focus(e);
              fFocusShowSalesHistoryGrid(e);
            }}
            xonBlur={xContent_Blur}
          // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
          lg={1}
          className={
            vRdxCheckbox.TDiscPercent ? "lastkeyDetect" : "hide-content"
          }
        >
          {/* <CmpTypographyField xcomponent={"div"} xText={"T.Disc %"} /> */}
          <CmpTextFieldV1
            xLabelText="T.Disc %"
            xSize="small"
            xValue={xBufferObj.B_TDiscPerc}
            xType={"text"} // text/number/password
            xName={"B_TDiscPerc"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsgDetail.B_TDiscPerc === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_TDiscPerc}
          // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
          lg={1}
          className={vRdxCheckbox.TDiscAmt ? "" : "hide-content"}
        >
          {/* <CmpTypographyField xcomponent={"div"} xText={"T.Disc Amt"} /> */}
          <CmpTextFieldV1
            xLabelText="T.Disc Amt"
            xSize="small"
            xValue={xBufferObj.B_TDiscAmt}
            xType={"text"} // text/number/password
            xName={"B_TDiscAmt"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsgDetail.B_TDiscAmt === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_TDiscAmt}
          // xOnKeyUp={xKey}
          />
        </Grid>

        <Grid
          item
          xs={4}
          sm={2}
          md={1}
          lg={1}
          className={
            vRdxCheckbox.LDiscPercent ? "lastkeyDetect" : "hide-content"
          }
        >
          {/* <CmpTypographyField xcomponent={"div"} xText={"L.Disc %"} /> */}
          <CmpTextFieldV1
            xLabelText={"L.Disc %"}
            xSize="small"
            xtabIndex={"106"}
            xValue={xBufferObj.B_LDiscPerc}
            xType={"number"} // text/number/password
            xName={"B_LDiscPerc"}
            xReadOnly={false}
            xOnChange={fLDiscPer}
            xError={xErrorMsgDetail.B_LDiscPerc === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_LDiscPerc}
            xonFocus={xContent_Focus}
            xonBlur={xContent_Blur}
          // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
          lg={1}
          className={vRdxCheckbox.LDiscAmt ? "lastkeyDetect" : "hide-content"}
        >
          {/* <CmpTypographyField xcomponent={"div"} xText={"L.Disc Amt"} /> */}
          <CmpTextFieldV1
            xLabelText="L.Disc Amt"
            xSize="small"
            xValue={xBufferObj.B_LDiscAmt}
            xType={"text"} // text/number/password
            xName={"B_LDiscAmt"}
            xReadOnly={false}
            xOnChange={fonChangeInputLDiscAmt}
            xError={xErrorMsgDetail.B_LDiscAmt === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_LDiscAmt}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}

          className={
            vRdxCheckbox.FOC ? "lastkeyDetect text-center " : "hide-content"
          }
          justifyContent={"center"}
        >
          {/* <CmpTypographyField xcomponent={"div"} xText={"FOC"} /> */}
          <CmpCheckboxField
            xtabIndex={"107"}
            xChecked={xBufferObj?.B_FocFlag === "Y"}
            xOnChange={fFoc}
            xDisabled={false}
            xName={"B_FocFlag"}
            xNameField={"FOC"}
            xError={xErrorMsgDetail.B_FocFlag === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_FocFlag}
              xlabelPlacement="end"
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
          lg={1}
          className={vRdxCheckbox.FOC ? "lastkeyDetect" : "hide-content"}
        >
          {/* <CmpTypographyField xcomponent={"div"} xText={"FOC Flag"} /> */}
          <CmpSelectArrFieldV1
            xtabIndex={"108"}
            xLabelText="FOC Flag"
            xValue={xBufferObj.B_AprmtFlag}
            xOnChange={fFocFlag}
            xName={"B_AprmtFlag"}
            xData={sFocFlagArr}
            xValueMember={""}
            xDispalyMember={""}
            xError={xErrorMsgDetail.B_AprmtFlag === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_AprmtFlag}
            xDisable={false}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
          lg={1}
          className={vRdxCheckbox.FOC ? "lastkeyDetect" : "hide-content"}
        >
          {/* <CmpTypographyField xcomponent={"div"} xText={"FOC Amount"} /> */}
          <CmpTextFieldV1
            xLabelText="FOC Amount"
            xSize="small"
            xValue={xBufferObj.B_FocAmt}
            xType={"text"} // text/number/password
            xName={"B_FocAmt"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsgDetail.B_FocAmt === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_FocAmt}
          // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
          lg={1}
          className={vRdxCheckbox.Excise ? "lastkeyDetect" : "hide-content"}
        >
          {/* <CmpTypographyField xcomponent={"div"} xText={"Excise"} /> */}
          <CmpTextFieldV1
            xLabelText="Excise"
            xSize="small"
            xtabIndex={"107"}
            xValue={xBufferObj.B_ExciseTaxAmt}
            xType={"number"} // text/number/password
            xName={"B_ExciseTaxAmt"}
            xReadOnly={false}
            xOnChange={fExcise}
            xError={xErrorMsgDetail.B_ExciseTaxAmt === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_ExciseTaxAmt}
            xonFocus={xContent_Focus}
            xonBlur={xContent_Blur}
          // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
          lg={1}
          className={vRdxCheckbox.Excise ? "lastkeyDetect" : "hide-content"}
        >
            <CmpTextFieldV1
            xLabelText="Net Excise"
            xSize="small"
            xValue={xBufferObj.B_ExciseTaxNetAmt}
            xType={"number"} // text/number/password
            xName={"B_ExciseTaxNetAmt"}
            xReadOnly={true}
            xOnChange={fNetExcise}
            xError={xErrorMsgDetail.B_ExciseTaxNetAmt === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_ExciseTaxNetAmt}
            xonFocus={xContent_Focus}
            xonBlur={xContent_Blur}
          // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid item xs={4} sm={2} md={1} lg={1} className="lastkeyDetect">
           <CmpTextFieldV1
            xLabelText="Net Value[L.C]"
            xSize="small"
            xtabIndex={"108"}
            xValue={xBufferObj.B_NetAmt}
            xType={"number"} // text/number/password
            xName={"B_NetAmt"}
            xReadOnly={true}
            xOnChange={fNetAmt}
            xError={xErrorMsgDetail.B_NetAmt === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_NetAmt}
          // xOnKeyUp={xKey}
          />
        </Grid>
        {/* <Grid item xs={4} sm={2} md={1} lg={1} className="lastkeyDetect">
         <CmpTextFieldV1
            xLabelText="Total"
            xSize="small"
            xtabIndex={"108"}
            xValue={xBufferObj.B_LandVal}
            xType={"number"} // text/number/password
            xName={"B_LandVal"}
            xReadOnly={true} 
          />
        </Grid> */}
        <Grid item xs={4} sm={2} md={1} lg={1}  className={vRdxCheckbox.BaseRate ? "lastkeyDetect" : "hide-content"}  >
          {/* <CmpTypographyField xcomponent={"div"} xText={"Base Rate"} /> */}
          <CmpTextFieldV1
            xLabelText="Base Rate"
            xSize="small"
            xValue={xBufferObj.B_Base_Rate}
            xType={"number"} // text/number/password
            xName={"B_Base_Rate"}
            xReadOnly={true}
            xOnChange={fBaseRate}
            xError={xErrorMsgDetail.B_Base_Rate === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_Base_Rate}
            xonFocus={xContent_Focus}
            xonBlur={xContent_Blur}
          // xOnKeyUp={xKey}
          />
        </Grid>

        <Grid
          item
          xs={4}
          sm={2}
          md={1}
          lg={1}
          className={vRdxCheckbox.Tax ? "lastkeyDetect" : "hide-content"}
        >
         <CmpSelectFieldV1
            xSize="small"
            xtabIndex={"109"}
            xLabelText="Tax Group"
            xValue={xBufferObj.B_TaxDept}
            xOnChange={fTaxGroup}
            xName={"B_TaxDept"}
            xData={vRdxGRNtax1}
            xValueMember={""}
            xDispalyMember={""}
            xError={xErrorMsgDetail.B_TaxDept === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_TaxDept}
            xDisable={false}
          // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
          lg={1}
          className={vRdxCheckbox.Tax ? "lastkeyDetect" : "hide-content"}
        >
          <CmpTextFieldV1
            xLabelText="Tax %"
            xSize="small"
            xValue={xBufferObj.B_TaxPerc}
            xType={"text"} // text/number/password
            xName={"B_TaxPerc"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsgDetail.B_TaxPerc === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_TaxPerc}
          // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
          lg={1}
          className={vRdxCheckbox.Tax ? "lastkeyDetect" : "hide-content"}
        >
          <CmpTextFieldV1
            xLabelText="Tax Amt"
            xSize="small"
            xValue={xBufferObj.B_TaxAmt}
            xType={"text"} // text/number/password
            xName={"B_TaxAmt"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsgDetail.B_TaxAmt === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_TaxAmt}
          // xOnKeyUp={(e) => {
          //   xFocusInput("B_TaxPerc2");
          // }}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1.2}
          lg={1.2}
          className={vRdxCheckbox.Cess ? "lastkeyDetect" : "hide-content"}
        >
          {/* <CmpTypographyField xcomponent={"div"} xText={"Cess Group"} /> */}
          <CmpSelectFieldV1
            xSize="small"
            xtabIndex={"110"}
            xLabelText="Cess Group"
            xValue={xBufferObj.B_TaxDept2}
            xOnChange={fCessGroup}
            xName={"B_TaxDept2"}
            xData={vRdxGRNtax2}
            xValueMember={""}
            xDispalyMember={""}
            xError={xErrorMsgDetail.B_TaxDept2 === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_TaxDept2}
            xDisable={false}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
          lg={1}
          className={vRdxCheckbox.Cess ? "lastkeyDetect" : "hide-content"}
        >
          {/* <CmpTypographyField xcomponent={"div"} xText={"Cess %"} /> */}
          <CmpTextFieldV1
            xLabelText="Cess %"
            xSize="small"
            xValue={xBufferObj.B_TaxPerc2}
            xType={"text"} // text/number/password
            xName={"B_TaxPerc2"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsgDetail.B_TaxPerc2 === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_TaxPerc2}
          // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
          lg={1}
          className={vRdxCheckbox.Cess ? "lastkeyDetect" : "hide-content"}
        >
          {/* <CmpTypographyField xcomponent={"div"} xText={"Cess Amt"} /> */}
          <CmpTextFieldV1
            xLabelText="Cess Amt"
            xSize="small"
            xValue={xBufferObj.B_TaxAmt2}
            xType={"text"} // text/number/password
            xName={"B_TaxAmt2"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsgDetail.B_TaxAmt2 === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_TaxAmt2}
          // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
          lg={1}
          className={vRdxCheckbox.Cess ? "lastkeyDetect" : "hide-content"}
        >
          {/* <CmpTypographyField xcomponent={"div"} xText={"Add Cess"} /> */}
          <CmpTextFieldV1
            xLabelText="Add Cess"
            xSize="small"
            xValue={xBufferObj.AddCess}
            xType={"text"} // text/number/password
            xName={"AddCess"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsgDetail.AddCess === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.AddCess}
          // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1.5}
          lg={1.5}
          className={vRdxCheckbox.Cess ? "lastkeyDetect" : "hide-content"}
        >
          {/* <CmpTypographyField xcomponent={"div"} xText={"Add Cess Amt"} /> */}
          <CmpTextFieldV1
            xLabelText="Add Cess Amt"
            xSize="small"
            xValue={xBufferObj.B_NetAddCess}
            xType={"text"} // text/number/password
            xName={"B_NetAddCess"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsgDetail.B_NetAddCess === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_NetAddCess}
          // xOnKeyUp={(e) => {
          //   xFocusInput("SplDiscPerc");
          // }}
          />
        </Grid>
         <Grid
                  item
                  xs={4}
                  sm={2}
                  md={0.5}
                  className="lastkeyDetect"
                  display={"flex  "}
                  alignItems={"center"}
                  justifyContent={"space-around"}
                >
                 
        
                  <div>
                    
                    {xMediaQuery && (
                       
                       <CmpButtonKWithIcon
                       xOnClick={(e) => {
                      
                        fModalContentOpen(e, "checkboxModal");
                      }}
                       xDisabled={false}
                       xIcon={<VisibilityIcon fontSize={"small"} />}
                       xcolor="primary"
                     />
                    )}
                  </div>
                </Grid>
      </Grid>

      <Modal
        open={sOpenContentModal}
        onClose={fModalContentClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="model-content-checkbox  ">
          <GCTitleSticky title={"Detail list"} onClose={fModalContentClose} />


          <div className="container-fluid">
            <div className="wms-label">
              <div className="checkbox-mb">
                <label className="form-label ">
                  <input
                    className="form-check-input "
                    type="checkbox"
                    name="AllChecked"
                    checked={sIsChecked}
                    onChange={(e) => {
                      fIsAllChecked(e);
                    }}
                  />{" "}
                  All
                </label>
              </div>
              <>
                {vModelCheckboxArr?.map((obj, index) => (
                  <div className="checkbox-mb" key={"Wmscheckbox" + index}>
                    <label className="form-label">
                      <input
                        className="form-check-input "
                        type="checkbox"
                        name={obj.name}
                        checked={obj.rdxName}
                        onChange={(e) => {
                          fSetCheckBox(e);
                        }}
                      />{" "}
                      {obj.name}
                    </label>
                  </div>
                ))}
              </>
            </div>
          </div>
        </Box>
      </Modal>
    </form>
  );
}
